import axios from 'axios'

export function workJson() {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: "/work.json",
            dataType: "json",
            crossDomain: true,
            cache: false
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            reject(error)
        })
    })
}